<template>
    <div class="grid grid-cols-2 gap-2">
        <div v-for="shippingProvider in shippingProviders"
             class="rounded light p-6 d-flex justify-content-center align-items-center cursor-pointer"
             :class="[bgClass(shippingProvider.code)]"
             @click="$emit('input', shippingProvider)"
        >
            <div>
                <img :src="shippingProvider.logo_url"
                     :alt="shippingProvider.name"
                     class="h-40px"
                >
            </div>
        </div>
        <div
            class="rounded bg-light-light bg-hover-secondary p-6 d-flex justify-content-center align-items-center cursor-pointer"
            @click="$emit('input', 'custom')"
        >
            <div>
                <span>{{ __('form.custom_input') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            types: [String, Object],
            default() {
                return '';
            }
        },
        shippingProviders: Array
    },

    mounted() {
        if (this.shippingProviders.length === 0) {
            this.$emit('input', 'custom')
        }
    },

    methods: {
        bgClass(integrationCode) {
            switch (integrationCode) {
                case 'GG':
                    return 'bg-light-gg bg-hover-light-gg'
                default:
                    return 'bg-light-light bg-hover-secondary'
            }
        }
    }
}
</script>
